module.exports = __webpack_public_path__ + "img/hea-img.12843cb9.png";